export enum DetailsFieldsNames {
  InsuranceProductId = 'insuranceProductId',
  Premium = 'premium',
  Limit = 'limit',
  AgentCommission = 'agentCommission',
  Comments = 'comments',
  ExpiresAt = 'expiresAt',
  Date = 'date',
  BinderDate = 'binderDate',
  SubLimits = 'subLimits',
  TriaPremium = 'triaPremium',
  CarrierFee = 'carrierFee',
  FlowBrokerFee = 'flowBrokerFee',
  SurplusLineTax = 'surplusLineTax',
  SurplusStampingFee = 'surplusStampingFee',
  Subjectivities = 'subjectivities',
  BinderSubjectivities = 'binderSubjectivities',
  PolicyNumber = 'policyNumber',
  PolicyEffectiveDate = 'policyEffectiveDate',
  PolicyExpirationDate = 'policyExpirationDate',
  FlowCommission = 'flowCommission',
  AttachmentPoint = 'attachmentPoint',
  StateCompliance = 'stateCompliance',
  BinderStateCompliance = 'binderStateCompliance',
  CoverageLines = 'coverageLines',
  FormType = 'formType',
}

export enum SubjectivitiesFieldsNames {
  Value = 'value',
}

export enum SubjectivitiesOpenItemsArrayFieldsNames {
  Type = 'type',
  Checked = 'checked',
}

export enum InsightsFieldsNames {
  Insights = 'insights',
}
